import { Alert, AlertTitle, Collapse } from "@mui/material";
import { FC } from "react";
import { IDicasProps } from "../../interfaces/IDicasProps";

const Dica: FC<Partial<IDicasProps>> = (props: Partial<IDicasProps>) => {
	return (
		<Collapse style={{ display: "block"}} in={true}>
			<Alert
				sx={{ mb: 2 }}
				severity="warning"
			>
				<AlertTitle>Atenção</AlertTitle>
				{props.frase}
			</Alert>
		</Collapse>
	);
}

export default Dica